import mealDeals from './meal-deals';

export default state => {
  return [mealDeals(state)];
};
